// apps/web/src/components/DemoAppInitializer.tsx
import React, { useEffect } from "react";
import { useUserContext } from "../contexts/UserContext";
import { setSelectedCompanyId } from "../utils/companyStorage";

export default function DemoAppInitializer({ children }: { children: React.ReactNode }) {
    const { setUserState } = useUserContext() as any; // 既存の更新関数に合わせて調整

    useEffect(() => {
        // companyStorage が前提なら「デモ会社」を固定セット
        setSelectedCompanyId("demo-company");

        // UserContext を「ログイン済み」に見せる（必要最小限のフィールドだけ）
        setUserState?.((prev: any) => ({
            ...prev,
            uid: "demo",
            tenantId: "demo",
            companyId: "demo-company",
            role: "admin",
            shopUrl: "demo-shop",
            plan: "demo",
            superAdmin: true,
            loading: false,
            status: "approved",
            error: null,
        }));
    }, [setUserState]);

    return <>{children}</>;
}
